import { Link } from "react-router-dom";
import { FaTrash, FaShoppingCart, FaHeart } from "react-icons/fa";
import PageHeader from "../../components/layout/PageHeader";
import { useShop } from "../../context/ShopContext";

export default function Wishlist() {
  const { wishlist, toggleWishlist, addToCart } = useShop();

  return (
    <>
      <PageHeader title="Wishlist" crumbs={[{ label: "Wishlist" }]} />
      <section className="section">
        <div className="container">
          {wishlist.length === 0 ? (
            <div className="empty-state">
              <div className="ei"><FaHeart /></div>
              <h3>Your Wishlist is Empty</h3>
              <p>Save your favourite products here for later.</p>
              <Link to="/shop-grid" className="btn btn-primary">Browse Shop</Link>
            </div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table className="cart-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Price</th>
                    <th>Action</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {wishlist.map((item) => (
                    <tr key={item.id}>
                      <td>
                        <Link to={`/shop/${item.id}`} className="cart-prod">
                          <img src={item.image} alt={item.name} />
                          <span>{item.name}</span>
                        </Link>
                      </td>
                      <td className="text-yellow">${item.price.toFixed(2)}</td>
                      <td>
                        <button className="btn btn-primary" onClick={() => addToCart(item)}>
                          <FaShoppingCart /> Add to Cart
                        </button>
                      </td>
                      <td>
                        <button className="cart-remove" onClick={() => toggleWishlist(item)}>
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
